import { z } from "zod";

export const onchainProofStatusSchema = z.enum(["PENDING", "PUBLISHED", "FAILED"]);

export const onchainProofSchema = z.object({
  id: z.string().uuid(),
  payPeriodId: z.string().uuid(),
  merkleRoot: z.string(),
  payPeriodPublicRef: z.string(),
  chain: z.string(),
  status: onchainProofStatusSchema,
  transactionSignature: z.string().nullable(),
  publishedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const generateOnchainProofResponseSchema = z.object({
  proof: onchainProofSchema,
  workerCount: z.number().int(),
});

export const publishOnchainProofResponseSchema = z.object({
  proof: onchainProofSchema,
});

export type OnchainProof = z.infer<typeof onchainProofSchema>;
export type GenerateOnchainProofResponse = z.infer<typeof generateOnchainProofResponseSchema>;
export type PublishOnchainProofResponse = z.infer<typeof publishOnchainProofResponseSchema>;
